import * as React from 'react';
import dayjs from 'dayjs';
import toast from 'cogo-toast';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Page, Grid, Card, Icon } from 'tabler-react';
import PageComponent from '../PageComponent';
import './account.scss';
import store from '../../shared/store';
import wechat from '../Login/social-wechat.svg';
import Request from '../../shared/request';
import i18n from '../../shared/i18n';

class TicketIndex extends PageComponent {
  state = {
    wechatModal: false,
    qrcodeURL: '',
    qrcodeBase64: '',
    UUID: '',
    wechatMessage: '',
    unbinding: false,
  };

  async componentDidMount() {
    await store.dispatch({ type: 'updateUser' });
  }

  saveToken = userInfo => {
    if (userInfo) {
      localStorage.setItem('login', JSON.stringify(userInfo));
      Cookies.set('malus-token', userInfo.token, {
        domain: `.${window.location.host
          .split('.')
          .slice(-2)
          .join('.')}`,
      });
    }
  };

  getUserInfo = async authorizationCode => {
    console.log(authorizationCode);
    const data = await Request.call('bindWechat', {
      authorizationCode,
    });
    if (data && data.token) {
      this.saveToken(data);
      toast.success(`${data.wechatName} 绑定成功`);
      window.location.reload();
      this.setState({ wechatMessage: '', wechatModal: false });
    } else {
      this.setState({ wechatMessage: '', wechatModal: false });
    }
  };

  getCode = async (uuid, time) => {
    const { status, result } = await Request.call(
      `getWechatCode?uuid=${uuid}&_=${time}`,
    );
    switch (status) {
      case 405:
        // 登陆成功
        this.setState({ wechatMessage: '正在绑定...' });
        this.getUserInfo(result.code);
        break;
      case 404:
        this.setState({ wechatMessage: '手机已扫描' });
        // 继续poll
        setTimeout(() => {
          this.getCode(this.state.UUID, Date.now());
        }, 1000);
        // 扫描成功
        break;
      case 403:
        this.setState({ wechatMessage: '', wechatModal: false });
        toast.warn('绑定已取消');
        // 取消本次登陆
        break;
      case 402:
      case 500:
        this.getUUID();
        // 重新获取uuid
        break;
      case 408:
        // 继续poll
        setTimeout(() => {
          this.getCode(window.wechatUUID, Date.now());
        }, 1000);
        break;
      default:
        break;
    }
  };

  getUUID = async () => {
    this.setState({ wechatModal: true });
    const data = await Request.call('getWechatLoginCode');
    if (data) {
      this.setState({ qrcodeBase64: data.qrcodeURL, UUID: data.UUID });
      this.getCode(this.state.UUID, Date.now());
    }
  };

  unbind = async () => {
    if (this.state.unbinding) {
      return
    }
    const data = await Request.call('unbindWechat');
    if (data) {
      this.saveToken(data);
    }
    window.location.reload()
  }

  render() {
    return (
      <Page.Content className="page-account">
        <Grid.Row>
          <Grid.Col>
            <Card title={i18n.t('dash-account-title')} className="account">
              <div className="body">
                {store.user && !store.user.email ? (
                  <Link to="/dashboard/bind-email" className="item">
                    <div className="label">{i18n.t('dash-account-email')}</div>
                    <div className="right">
                      <div className="btn-bind">{i18n.t('dash-account-bind')}</div>
                      <i className="fa fa-angle-right" />
                    </div>
                  </Link>
                ) : (
                  <div className="item">
                    <div className="label">{i18n.t('dash-account-email')}</div>
                    <div className="right">{store.user.email}</div>
                  </div>
                )}

                {store.user && !store.user.phone ? (
                  <Link to="/dashboard/bind-email?tab=phone" className="item">
                    <div className="label">{i18n.t('dash-account-phone')}</div>
                    <div className="right">
                      <div className="btn-bind">{i18n.t('dash-account-bind')}</div>
                      <i className="fa fa-angle-right" />
                    </div>
                  </Link>
                ) : (
                  <div className="item">
                    <div className="label">{i18n.t('dash-account-phone')}</div>
                    <div className="right">{store.user.phone}</div>
                  </div>
                )}

                <div className="item">
                  <div className="label">{i18n.t('dash-account-expire')}</div>
                  {store.user && store.user.planExpiredAt === 0 ? (
                    <div className="right">{i18n.t('dash-account-free')}</div>
                  ) : (
                    <div className="right">
                      {dayjs(store.user.planExpiredAt).format('YYYY.MM.DD')}
                      <span>
                        {store.user.planMode === 'SUBSCRIPTION'
                          ? ' / ' + i18n.t('dash-account-subscription')
                          : ''}
                      </span>
                    </div>
                  )}
                </div>
                {!store.user.wechatName ? (
                  <div className="item" onClick={this.getUUID}>
                    <div className="label">{i18n.t('dash-account-wechat')}</div>
                    <div className="right">
                      <span>{i18n.t('dash-account-bind')}</span>
                      <i className="fa fa-wechat" />
                      <i className="fa fa-angle-right" />
                    </div>
                  </div>
                ) : (
                  <div className="item">
                    <div className="label">{i18n.t('dash-account-wechat')}</div>
                    <div className="right">
                      <span onClick={this.unbind}>{this.state.unbinding ? i18n.t('dash-account-unbinding')+'...' : <div className="btn-bind">{i18n.t('dash-account-unbind')}{store.user.wechatName}</div>}</span>
                      <i className="fa fa-wechat" />
                    </div>
                  </div>
                )}
                <PasswordNav />
                {store.user.privcateServer ? (
                  <div className="item">
                    <div className="label">启用合租线路</div>
                    <div className="right">
                      <span>{`${store.user.privcateServer}`}</span>
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {store.user.clients > 0 ? (
                  <div className="item">
                    <div className="label">{i18n.t('dash-account-devices')}</div>
                    <a className="right" href="/dashboard/bind">
                      <span>{`${store.user.clients}`}</span> 台
                      <i className="fa fa-angle-right" />
                    </a>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </Card>
            <div
              className={`wechat-login ${
                this.state.wechatModal ? '' : 'hidden'
              }`}>
              <Card className="content">
                <Card.Header>
                  <Card.Title>
                    <img src={wechat} alt="wechat" />
                    {i18n.t('dash-account-wechat')}
                  </Card.Title>
                  <div
                    className="closed"
                    onClick={() =>
                      this.setState({ wechatModal: false, wechatMessage: '' })
                    }>
                    <Icon name="x" />
                  </div>
                </Card.Header>
                <Card.Body>
                  <div className="qrcode">
                    <img src={this.state.qrcodeBase64} alt="" />
                  </div>
                  <span className="wechat-message">
                    {this.state.wechatMessage}
                  </span>
                </Card.Body>
              </Card>
            </div>
          </Grid.Col>
        </Grid.Row>
      </Page.Content>
    );
  }
}

const PasswordNav = () => {
  if (store.user.needSetPassword && store.user.email) {
    return (
      <Link to="/dashboard/set-password" className="item">
        <div className="label">{i18n.t('dash-account-setpassword')}</div>
        <div className="right">
          <i className="fa fa-angle-right" />
        </div>
      </Link>
    );
  }
  if (!store.user.needSetPassword && store.user.email) {
    return (
      <Link to="/dashboard/account-password" className="item">
        <div className="label">{i18n.t('dash-account-updatepassword')}</div>
        <div className="right">
          <i className="fa fa-angle-right" />
        </div>
      </Link>
    );
  }
  return <></>;
};

export default TicketIndex;
